export function doNothing(...params: any[]): void {}
